import { gql } from '@apollo/client';

export const GET_HONORARIOS_FIDELIZADOS = gql`
  query getHonorariosFidelizados(
    $idDelegacion: Int
    $idTipoProfesional: Int
    $activo: Boolean!
  ) {
    honorariosFidelizados(
      idDelegacion: $idDelegacion
      idTipoProfesional: $idTipoProfesional
      activo: $activo
    ) {
      idHonorarioFidelizado
      descripcion
      idDelegacion
      idTipoProfesional
      idFiguraProfesional
      idClaseMonitoreo
      importe
      fechaExpira
      activo
      observacion
      idDelegacionNavigation { descripcion }
      idTipoProfesionalNavigation { descripcion }
      idFiguraProfesionalNavigation { descripcion }
      idClaseMonitoreoNavigation { descripcion }
      honorarioFidelizadoProfesional {
        idHonorarioFidelizadoProfesional
        idProfesional
        idProfesionalNavigation {
          nombre
          apellido
          idTipoDocumentoNavigation { descripcion }
          numeroDoc
        }
      }
    }
  }
`;

export const adaptHonorarioFidelizado = (h) => ({
  id:                      h.idHonorarioFidelizado,
  descripcion:             h.descripcion,
  idDelegacion:            h.idDelegacion,
  delegacion:              h.idDelegacionNavigation?.descripcion ?? '-',
  idTipoProfesional:       h.idTipoProfesional,
  tipoProfesional:         h.idTipoProfesionalNavigation?.descripcion ?? '-',
  idFiguraProfesional:     h.idFiguraProfesional,
  figura:                  h.idFiguraProfesionalNavigation?.descripcion ?? '-',
  idClaseMonitoreo:        h.idClaseMonitoreo,
  clase:                   h.idClaseMonitoreoNavigation?.descripcion ?? '-',
  importe:                 h.importe,
  fechaExpira:             h.fechaExpira,
  activo:                  h.activo,
  observacion:             h.observacion,
  profesionalesIncluidos:  h.honorarioFidelizadoProfesional ?? [],
});

export const adaptHonorariosFidelizadosArray = (data) =>
  structuredClone(data?.honorariosFidelizados)?.map(adaptHonorarioFidelizado) ?? [];